import React from "react";
import "./CSS/style.css";
import "./CSS/media.css";

function About() {
  return (
    <div className="about container-fluid">
      <div className="container about__container">
        <div className="row">
          <div className="col-md-6 about__title">
            <h4>01.</h4>
            <h3>About Me</h3>
            <span></span>
          </div>
        </div>
        <div className="row">
          <div className="col-md-7">
            <p className="about__me">
              Hello! My name is Shah Saud Khan and I'm a front end developer
              specializing in building (and occassionally designing) exceptional
              digital experiences. I enjoy creating things that live on the
              internet. My interest in web development started back in 2019. I
              started my coding journey from Web Desiging then Developing . At
              the beggining i mastered html css all the way to react.My vision
              is to become a blockchain developer.
              <br />
              <br />
              Fast-forward to today, I've had the privilege of working at a{" "}
              <a
                target="_blank"
                href="https://www.facebook.com/kha.skp.03/?ref=page_internal"
              >
                school
              </a>
              , a{" "}
              <a target="_blank" href="https://spacsmen.com/">
                start-up
              </a>{" "}
              and a{" "}
              <a target="_blank" href="https://surgengin.com/">
                design house
              </a>
              . My goal these days is to build my interactive content at{" "}
              <a target="_blank" href="http://property051.com/">
                Property-051
              </a>
              .
            </p>
            <div className="about__skills">
              <p>
                Here are a few technologies I've been working with recently:
              </p>
              <ul>
                <li>JavaScript</li>
                <li>React/Redux</li>
                <li>Ether.js/Web3.js</li>
                <li>Solidity</li>
                <li>Node.Js</li>
                <li>Wordpress</li>
                <li>BootStrap | Tailwind</li>
                <li>Nextjs</li>
                <li>Git/GitHub</li>
              </ul>
            </div>
          </div>
          <div className="col-md-5">
            <div className="about__img">
              <img src="/img/new.jpg" alt="" />
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
